import React, { useState, useEffect } from "react";
import { Grid, Box, TextField, Button, MenuItem } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useDispatch } from "react-redux";
import { Done } from "@mui/icons-material";

const TSignUp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orgName = location.state;
  const dispatch = useDispatch();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [otpVerification, setOtpVerification] = useState(1);
  const [otpvalue, setOtpvalue] = useState("");
  //TO SET FEILD VALUES
  const [formData, setFormData] = useState({
    CompanyName: orgName || "",
    ContactPersonName: "",
    NoOfTikketingWebAppLicense: "",
    NoOfTikketingMobileAppLicense: "",
    MobileNumber1: "",
    EmailId1: "",
    Address: "",
    Area: "",
    Country: "",
    State: "",
    City: "",
    Pincode: "",
    countryCode: "",
  });

  const leftContent = [
    {
      name: " Real-Time Ticket Tracking",
      name1: "Moniter Your Support Request Instantly",
      color: "#DBEAFE",
      color1: "#155DFC",
    },
    {
      name: " Faster resolution",
      name1: "Get your issues resolved quickly",
      color: "#F3E8FF",
      color1: "#9810FA",
    },
    {
      name: " Easy ticket management",
      name1: "Organize and prioritize with ease",
      color: "#E0E7FF",
      color1: "#4F39F6",
    },
  ];
  const getCountries = async () => {
    try {
      const response = await $axios.get("auth/countryList");
      if (response.data.Status == 200) {
        setCountries(response.data.Message);
        setFormData({
          ...formData,
          Country: 101,
        });
        setFormData((prev) => ({
          ...prev,
          countryCode: 91,
        }));
      }
    } catch (error) {
      console.log("getCountries", error);
    }
  };

  const getStates = async () => {
    try {
      const response = await $axios.post(`auth/StateList`, {
        CountryId: formData.Country,
      });
      if (response.data.Status == 200) {
        setStates(response.data.Message);
        setFormData({ ...formData, State: response.data.Message[0]?.StateId });
      }
    } catch (error) {
      console.log("getCountries", error);
    }
  };

  const getCities = async () => {
    try {
      const response = await $axios.post(`auth/CityList`, {
        StateId: formData.State,
      });
      if (response.data.Status == 200) {
        setCities(response.data.Message);
        setFormData({ ...formData, City: response.data.Message[0]?.CityId });
      }
    } catch (error) {
      console.log("getCountries", error);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await $axios.post("auth/onboarding", formData);
      if (response.data.Status == 200) {
        toast.success("User Created");
        navigate("/auth");
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };

  const generateOtp = async () => {
    const anyEmpty = Object.values(formData).every((value) => value != "");
    if (!anyEmpty) {
      toast.error("Kindly Fill All Details");
      return;
    }
    try {
      let payload = {
        Mobile: formData.MobileNumber1,
        countryCode: formData.countryCode.toString(),
        name: formData.ContactPersonName,
      };
      const { data } = await $axios.post("auth/generateOtp", payload);
      if (data.Status == 200) {
        toast.success("OTP Sent To Your Mobile Number");
        setOtpVerification(2);
      } else {
        toast.error(data.Message);
      }
    } catch (error) {
      console.log("generateOtp", error);
    }
  };

  const verifyotp = async (val) => {
    if (val ? val.length != 6 : otpvalue.length != 6) {
      toast.error("OTP Missing");
      return;
    }
    try {
      let payload = {
        Mobile: formData.MobileNumber1,
        countryCode: formData.countryCode.toString(),
        otp: val || otpvalue,
      };
      const { data } = await $axios.post("auth/otpVerify", payload);
      if (data.Status == 200) {
        toast.success("Verification Completed Successfully");
        setOtpVerification(3);
      } else {
        toast.error(data.Message);
      }
    } catch (error) {
      console.log("generateOtp", error);
    }
  };

  const logout = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      let payload = {
        token: refreshToken,
      };
      const response = await $axios.post(`${global.logout}signout`, payload);
      console.log("logoutresponse", response.data);
      if (response.data.status) {
        dispatch({ type: "SET_USER_OUT", payload: false });
        localStorage.clear();
        navigate("/auth");
      }
    }
  };

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (formData.Country) {
      getStates();
    }
  }, [formData.Country]);

  useEffect(() => {
    if (formData.State) getCities();
  }, [formData.State]);

  return (
    <Grid style={style.mainBg} container>
      <Grid
        item
        sx={{
          paddingTop: { lg: "1%", xl: "5%" },
          paddingBottom: { lg: "1%", xl: "5%" },
        }}
        xs={5}
        style={style.leftContent}
      >
        <div style={style.leftContent1}>
          <Box style={style.headStyle}>
            <img
              src="/whiteTicket.svg"
              style={style.whiteTicket}
              alt="TicketIcon"
            />
            <p>Ticketing</p>
          </Box>
          <Box
            style={{
              fontWeight: "normal",
              color: "#CCE3F2",
            }}
            sx={{ fontSize: "36px" }}
          >
            Welcome To Smart
            <Box
              style={{
                color: "#FFFF",
                fontWeight: "bold",
              }}
              sx={{ fontSize: "36px" }}
            >
              Ticketing
            </Box>
          </Box>
          <Box
            style={{
              color: "#FFFF",
            }}
            sx={{ fontSize: "16px" }}
          >
            Easily raise, manage, and track support tickets with real-time
            updates and faster resolution.
          </Box>
        </div>

        <div>
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 30,
            }}
          >
            {leftContent.map((item, index) => (
              <Box
                key={index}
                style={style.lcontentArr}
                sx={{ width: { lg: "90%", xl: "80%" } }}
              >
                <div
                  style={{
                    borderRadius: "50px",
                    backgroundColor: `${item?.color}`,
                    padding: "10px",
                  }}
                >
                  <Done sx={{ color: `${item?.color1}` }} />
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 5 }}
                >
                  <div style={{ fontWeight: "bold" }}>{item.name}</div>
                  <div>{item?.name1}</div>
                </div>
              </Box>
            ))}
          </Box>
        </div>
      </Grid>
      <Grid item xs={7} style={style.ticketIcon}>
        <Grid
          style={style.ticketIcon1}
          sx={{ boxShadow: 3, width: { md: "60%", xl: "40%" } }}
          container
        >
          {otpVerification == 1 ? (
            <Grid style={style.insideForm} container>
              <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <p>Create Your Account</p>
                <p style={{ color: "#4A5565" }}>
                  Enter your company and contact details to get started.
                </p>
              </div>
              <Grid xs={12} item>
                <p>Company Details</p>
                <TextField
                  id="outlined-basic"
                  color="primary"
                  label="Company Name"
                  fullWidth
                  disabled
                  value={formData.CompanyName}
                  required
                />
              </Grid>
              <Grid xs={12} style={{ marginTop: 10 }} item>
                <p>No Of License</p>
                <TextField
                  id="outlined-basic"
                  color="primary"
                  label="No of Licenses"
                  fullWidth
                  value={formData.NoOfTikketingWebAppLicense}
                  inputMode="number"
                  required
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      NoOfTikketingWebAppLicense: e.target.value,
                      NoOfTikketingMobileAppLicense: e.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid
                style={{
                  marginTop: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
                xs={12}
                item
              >
                <p>Contact Info</p>
                <TextField
                  id="outlined-basic"
                  color="primary"
                  label="Contact Name"
                  fullWidth
                  value={formData.ContactPersonName}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      ContactPersonName: e.target.value,
                    });
                  }}
                  required
                />

                <Grid xs={12} item>
                  <TextField
                    id="outlined-basic"
                    color="primary"
                    label="Mobile Number"
                    placeholder="OTP Verification"
                    fullWidth
                    type="number"
                    value={formData.MobileNumber1}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        MobileNumber1: e.target.value,
                      });
                    }}
                    required
                  />
                </Grid>
                <Grid xs={12} item>
                  <TextField
                    id="outlined-basic"
                    color="primary"
                    label="Email"
                    fullWidth
                    type="email"
                    value={formData.EmailId1}
                    onChange={(e) => {
                      setFormData({ ...formData, EmailId1: e.target.value });
                    }}
                    required
                  />
                </Grid>
              </Grid>

              <Grid
                style={{
                  marginTop: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
                xs={12}
                item
              >
                <p>Address Info</p>
                <Grid xs={12} item>
                  <TextField
                    id="outlined-basic"
                    color="primary"
                    label="Address"
                    fullWidth
                    multiline
                    maxRows={4}
                    value={formData.Address}
                    onChange={(e) => {
                      setFormData({ ...formData, Address: e.target.value });
                    }}
                    required
                  />
                </Grid>
                <Grid xs={12} item>
                  <TextField
                    id="outlined-basic"
                    color="primary"
                    label="Area"
                    fullWidth
                    multiline
                    maxRows={4}
                    value={formData.Area}
                    onChange={(e) => {
                      setFormData({ ...formData, Area: e.target.value });
                    }}
                    required
                  />
                </Grid>

                <Grid item container sx={{}} spacing={2}>
                  <Grid xs={6} item>
                    <TextField
                      required
                      id="outlined-select-currency-native"
                      select
                      label="Select Country"
                      color="primary"
                      fullWidth
                      value={formData.Country}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          Country: e.target.value,
                        });
                        const selected = countries.find(
                          (val) => val?.CountryId == e.target.value
                        );

                        setFormData((prev) => ({
                          ...prev,
                          countryCode: selected?.phonecode,
                        }));
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                            },
                          },
                        },
                      }}
                    >
                      {countries.map((option) => (
                        <MenuItem
                          key={option.CountryId}
                          value={option.CountryId}
                        >
                          {option.CountryName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid xs={6} item>
                    <TextField
                      required
                      id="outlined-select-currency-native"
                      select
                      label="Select State"
                      color="primary"
                      fullWidth
                      value={formData.State}
                      onChange={(e) => {
                        setFormData({ ...formData, State: e.target.value });
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                            },
                          },
                        },
                      }}
                    >
                      {states.map((option) => (
                        <MenuItem key={option.StateId} value={option.StateId}>
                          {option.StateName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid xs={6} item>
                    <TextField
                      required
                      id="outlined-select-currency-native"
                      select
                      label="Select City"
                      color="primary"
                      fullWidth
                      value={formData.City}
                      onChange={(e) => {
                        setFormData({ ...formData, City: e.target.value });
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                            },
                          },
                        },
                      }}
                    >
                      {cities.map((option) => (
                        <MenuItem key={option.CityId} value={option.CityId}>
                          {option.CityName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid xs={6} item>
                    <TextField
                      required
                      id="outlined-basic"
                      type="number"
                      color="primary"
                      label="Pincode"
                      fullWidth
                      value={formData.Pincode}
                      onChange={(e) => {
                        setFormData({ ...formData, Pincode: e.target.value });
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : otpVerification == 2 ? (
            <Grid
              style={{ ...style.insideForm, padding: "10px" }}
              container
              direction="column"
              spacing={1}
              alignItems={"center"}
            >
              <div style={style.content3}>
                <img
                  onClick={() => setOtpVerification("1")}
                  src="/backArrow.svg"
                  width={25}
                  height={25}
                  alt="Back Arrow"
                  style={{ cursor: "pointer" }}
                />
                Back
              </div>
              <div style={style.verifyotp}>
                <p style={{ fontSize: "20px" }}>Verify OTP</p>
                <p>{`We've sent a verification code to ${formData.MobileNumber1}`}</p>
              </div>
              <MuiOtpInput
                length={6}
                value={otpvalue}
                onChange={(e) => {
                  setOtpvalue(e);
                  if (e.length === 6) {
                    verifyotp(e);
                  }
                }}
                TextFieldsProps={{
                  sx: {
                    color: "black",
                    width: "40px",
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    borderColor: "#ACDEFF",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "#ACDEFF",
                    },
                  },
                }}
              />
            </Grid>
          ) : (
            <Grid
              style={style.insideForm}
              container
              direction="row"
              spacing={1}
              justifyContent={"center"}
            >
              <div>{`Please complete the final submission to log in.`}</div>
              <Grid style={{ marginTop: "20px" }} xs={12} item>
                <TextField
                  id="outlined-basic"
                  color="primary"
                  label="Mobile Number"
                  placeholder="OTP Verification"
                  fullWidth
                  type="number"
                  value={formData.MobileNumber1}
                  disabled
                />
              </Grid>
              <Grid xs={12} item>
                <TextField
                  id="outlined-basic"
                  color="primary"
                  label="Email"
                  fullWidth
                  type="email"
                  value={formData.EmailId1}
                  disabled
                />
              </Grid>
            </Grid>
          )}
          <div style={style.buttons}>
            <Button
              onClick={
                otpVerification == 2
                  ? verifyotp
                  : otpVerification == 3
                  ? handleSubmit
                  : generateOtp
              }
              style={{ margin: "20px" }}
              variant="contained"
            >
              {otpVerification == 2
                ? "Verify OTP"
                : otpVerification == 3
                ? "Submit"
                : "Continue"}
            </Button>
            <div style={{ display: "flex" }}>
              {otpVerification != 3 && (
                <Button onClick={logout} style={{ cursor: "pointer" }}>
                  Switch Accounts
                </Button>
              )}
              {otpVerification == 2 && (
                <Button
                  onClick={generateOtp}
                  style={{ cursor: "pointer", color: "#BE4F51" }}
                >
                  Resend code
                </Button>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        fontSize={"14px"}
        fontWeight={"600"}
        color={"#232323"}
      />
    </Grid>
  );
};

const style = {
  verifyotp: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "start",
    alignItems: "start",
    marginTop: "20px",
  },
  content3: {
    display: "flex",
    width: "100%",
    justifyContent: "start",
    alignItems: "center",
    gap: 10,
  },
  lcontentArr: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: 20,
    borderRadius: "10px",
    border: 1,
    padding: "10px",
    backgroundColor: "white",
  },
  insideForm: { width: "100%", overflow: "auto", maxHeight: "80%" },
  buttons: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  ticketIcon1: {
    borderRadius: "20px",
    backgroundColor: "white",
    padding: "20px",
    maxHeight: "90vh",
    border: "20px",
  },
  leftContent1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    height: "40%",
  },
  whiteTicket: { width: "45px", height: "45px", marginBottom: "10px" },
  leftContent: {
    backgroundColor: "#0071BC",
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    paddingLeft: "5%",
    paddingRight: "5%",
    justifyContent: "space-between",
  },
  mainBg: {
    height: "100vh",
    width: "100%",
    backgroundImage: 'url("/login_BG.svg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
  },
  ticketIcon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
  },
  headStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    color: "#FFFF",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "25.48px",
    lineHeight: "100%",
    gap: 10,
  },
};

export default TSignUp;
